// The supplier portal frame (Lane 1331; new look Lane 1394): top bar, the
// person's name, Sign out.
//
// The signed-in shell loads /me once and shares it with the page through a
// small context of its own. It never reads the buyer AuthContext.
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { portalApi, getPortalToken, clearPortalToken, PORTAL_HOME, PORTAL_LOGIN } from './portalApi';
import '../ListLinear.css';
import './SourcingPortal.css';

const PortalSession = createContext(null);

export function usePortalSession() {
  return useContext(PortalSession);
}

function TopBar({ user, onSignOut, signingOut }) {
  return (
    <div className="srcp-bar">
      <Link to={user ? PORTAL_HOME : PORTAL_LOGIN} className="srcp-brand">
        <span className="srcp-logo" aria-hidden="true">W</span>
        <span>Wingman <span className="srcp-brand-sub">supplier portal</span></span>
      </Link>
      {user && (
        <span className="srcp-bar-right">
          <span className="srcp-bar-name">{user.full_name || user.email}</span>
          <button type="button" className="srcp-btn srcp-btn--sm" disabled={signingOut} onClick={onSignOut}>
            {signingOut ? 'Signing out…' : 'Sign out'}
          </button>
        </span>
      )}
    </div>
  );
}

// For the join and sign-in pages: the frame without a session.
export function PublicShell({ children }) {
  return (
    <div className="ll srcp-app">
      <TopBar user={null} />
      <main className="srcp-wrap srcp-wrap--narrow">{children}</main>
    </div>
  );
}

export default function PortalShell({ children }) {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [error, setError] = useState('');
  const [signingOut, setSigningOut] = useState(false);
  const hasToken = Boolean(getPortalToken());

  const reload = useCallback(() => portalApi.me()
    .then((r) => { setMe(r); setError(''); return r; })
    .catch((e) => { if (e.status !== 401) setError(e.message); return null; }), []);

  useEffect(() => {
    if (!hasToken) { navigate(PORTAL_LOGIN, { replace: true }); return; }
    reload();
  }, [hasToken, navigate, reload]);

  const signOut = async () => {
    setSigningOut(true);
    try { await portalApi.logout(); } catch (e) { /* the token is cleared below either way */ }
    clearPortalToken();
    navigate(PORTAL_LOGIN, { replace: true });
  };

  if (!hasToken) return null;
  return (
    <div className="ll srcp-app">
      <TopBar user={me && me.user} onSignOut={signOut} signingOut={signingOut} />
      <main className="srcp-wrap">
        {error && <div className="srcp-error" role="alert">{error}</div>}
        {!me && !error && <div className="srcp-loading">Loading…</div>}
        {me && <PortalSession.Provider value={{ me, reload }}>{children}</PortalSession.Provider>}
      </main>
    </div>
  );
}
